import * as React from 'react';
import { formatYear, validateVehicleYear } from '@funnels/utils';
import TextInputField, { TextInputFieldProps } from '.';

const VehicleYearInputField = (props: TextInputFieldProps) => {
  const { ...rest } = props;
  return (
    <TextInputField
      validate={validateVehicleYear('The model year must be above 1900')}
      type="number"
      fixedLength={4}
      parse={formatYear}
      inputMode="numeric"
      {...rest}
    />
  );
};

export default VehicleYearInputField;
